//src/components/PatientHeroSection.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './PatientHeroSection.css';

const PatientHeroSection = () => {
    const [specialty, setSpecialty] = useState('');
    const [location, setLocation] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevents the default form submission
        console.log('Searching for:', specialty, 'in', location);
        // Here, you can add the logic to handle the search, like API calls
    };

    return (
        <div className="hero-section">
            <h1 className="hero-heading">Discover and schedule appointments with reliable doctors</h1>
            <div className="search-container">
                <form className="search-boxes" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Specialty"
                        className="search-input"
                        value={specialty}
                        onChange={(e) => setSpecialty(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Location"
                        className="search-input"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    />
                    <button className="search-button" type="submit" aria-label="Search">
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PatientHeroSection;
